import { Outlet } from "react-router-dom"
import Footer from "components/blocks/footer/Footer";
import Header from "components/blocks/header/Header";
import "./Page.css"
import { AppContext } from "contexts/AppContext";
import { useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { CprMitIdPopUp } from "components/blocks/cprMitIdPopup/CprMitIdPopUp";
import { useMediaQuery } from "@mui/material";

const jss = createUseStyles({
    ContentWrapper: {
        marginTop: (styleGuide) => styleGuide.headerHeight,
    },
    "@media screen and (max-width: 900px)": {
        ContentWrapper: {
            marginTop: (styleGuide) => styleGuide.headerHeightMobile,
        },
    },
});

const Page = (props) => {
    const { styleGuide, brandData, announcements } = useContext(AppContext);
    const isMobile = useMediaQuery('(max-width:900px)');
    const classes = jss(styleGuide);

    useEffect(() => {
        const body = document.getElementsByTagName('body')[0]
        body.style.backgroundColor = brandData.features && brandData.features.largeScreenBackground 
        ?   brandData.features.largeScreenBackground
        :   styleGuide.color3

        return () => {
            const body = document.getElementsByTagName('body')[0]
            body.style.backgroundColor = ''
        }
    }, [brandData]);
    
    return <>
        <div className="page-wrapper" >
            {!isMobile && !!announcements?.length &&
                <div style={{height: announcements.length * 30}} />
            }
            <Header style={headerPosition} />
            <div className={`${classes.ContentWrapper} content-wrapper`}>
                {!!brandData?.features?.LaunchCPRPopupAfterLogin && <CprMitIdPopUp />}
                <Outlet />
            </div>
            <Footer style={footerPosition} />
        </div>
    </>
}

const headerPosition = {
    position: 'absolute',
    width: '100%',
    top: 0
}

const footerPosition = {
    position: 'absolute',
    width: '100%',
    bottom: 0
}

export default Page